import { AxiosResponse } from "axios";
import { format } from "date-fns";
import React, { useContext, useEffect, useState } from "react";
import { AiOutlineLink } from "react-icons/ai";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { Table } from "rsuite";
import { UserContext } from "../../component/layout/layout";
import ViewCandidateHistoryModal from "../../component/manageCandidate/viewCandidateHistoryModal/viewCandidateHistoryModal";
import CandidateRequestModal from "../../component/manageRequest/candidateRequestModal";
import { UpdateOrderBy } from "../utils/api";
import { CommonConstants } from "../utils/CommonConstants";
import {
  axiosUpdate,
  checkCurrentRoleIsSuperAdmin,
  GetUserDateFormat,
} from "../utils/helper";
import { EPOverLay } from "./overLay";
import { CANDIDATE_STATUS, CANDIDATE_STATUS_LABEL } from "../utils/constant";

const { Column, ColumnGroup, HeaderCell, Cell } = Table;
interface Column {
  key: string;
  label: string;
  width?: number;
  fixed?: boolean;
  sortable?: boolean;
  flexGrow?: number;
  resizable?: boolean;
  align?: "center" | "left" | "right" | undefined;
  totalRecords?: number;
  IsColumnGroup?: boolean;
  ColumnGroups?: any;
  title?: string;
}
interface Props {
  data?: any;
  columns?: any;
  RequirementId?: any;
  height?: number;
  sortColumn?: string;
  sortType?: any;
  onSortColumn?: any;
  loading?: boolean;
  rowHeight?: number;
  headerHeight?: number;
  setDataList?: any;
  listName?: string;
  functionMethod?: any;
  refresher?: boolean;
  totalRecords?: number;
  setData?: any;
  HandleModel?: any;
  user?: any;
  setLoading?: any;
  setRefresher?: React.Dispatch<React.SetStateAction<boolean>>;
  PageAccess?: string[];
  wordWrap?: any;
  recruiterData?: any;
  recruiterColors?: any;
  availableLimit?: number;
  setAvailableLimit?: any;
}
const OrderByEditing = ({ ...props }) => {
  const [displaySequence, setDisplaySequence] = useState(
    props.rowData.DisplaySequence
  );

  useEffect(() => {
    setDisplaySequence(props.rowData.DisplaySequence);
  }, [props.rowData]);
  const handleInputChange = (event: any) => {
    const input = event.target.value;
    const numericInput = input.replace(/[^0-9]/g, "");
    if (numericInput !== "") {
      const number = parseInt(numericInput);
      const maxRecord = props.totalRecords;

      if (number >= 1 && number <= maxRecord) {
        setDisplaySequence(number.toString());
      } else {
        toast.warning(
          `You can only change order between range 1 and ${props.totalRecords} .`,
          {
            position: toast.POSITION.TOP_CENTER,
          }
        );
      }
    } else {
      setDisplaySequence("");
    }
  };

  const handleInputBlur = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      updateEducation(`${UpdateOrderBy}/${props.rowData.Id}`, reqBody);
      window.location.reload();
    }
  };
  const handleKeyDown = (event: any) => {
    if (event.key === "Tab") {
      setDisplaySequence(props.rowData.DisplaySequence);
    }
  };

  let reqBody = {
    Id: props.rowData.Id,
    DisplaySequence: displaySequence,
  };
  async function updateEducation(reqUrl: string, reqBody: any) {
    let response = (await axiosUpdate(reqUrl, { reqBody })) as AxiosResponse;
    if (
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "success"
    ) {
      toast.success("Display Sequence updated successfully", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (
      response.status == CommonConstants.API_RESPONSE_SUCCESSFULL &&
      response.data?.status === "error"
    ) {
      toast.warning("Education Order already exists", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
  return (
    <Cell {...props}>
      <input
        type="text"
        maxLength={3}
        value={displaySequence}
        onChange={handleInputChange}
        onKeyPress={handleInputBlur}
        onKeyDown={handleKeyDown}
      />
    </Cell>
  );
};
// Display Experiance column
const ExperienceCell = ({ ...props }) => (
  <Cell {...props}>
    <span>
      {props.rowData.ExperienceMin} - {props.rowData.ExperienceMax}
    </span>
  </Cell>
);
const Experience = ({ ...props }) => (
  <>
    <Cell {...props}>
      <span>
        {props.rowData.Experience}
        {`${props.listName == "leadTimeReport" ? "" : " Year"}`}
      </span>
    </Cell>
  </>
);

const ExperienceMonth = ({ ...props }) => (
  <>
    <Cell {...props}>
      <span>
        {props.rowData.ExperienceMonth}
      </span>
    </Cell>
  </>
);
const Round = ({ ...props }) => (
  <Cell {...props}>
    <span
      title={`${props.rowData.Round} ${
        props.rowData.RoundCount ? ` - ${props.rowData.RoundCount}` : ""
      }`}
    >
      {`${props.rowData.Round} ${
        props.rowData.RoundCount ? ` - ${props.rowData.RoundCount}` : ""
      }`}
    </span>
  </Cell>
);

const RecruiterSubCell = ({
  candidates,
  recruiterColors,
  renderContent,
}: {
  candidates: any[];
  recruiterColors: Record<string, string>;
  renderContent: (candidate: any) => React.ReactNode;
}) => (
  <>
    {candidates.map((candidate: any, index: number) => {
      // Use recruiter color, or fall back to a palette color by index
      const color =
        recruiterColors?.[candidate?.CreatedByEmployeeId];

      return (
        <div
          key={index}
          style={{
            borderLeft: `8px solid ${color}`,
            backgroundColor: `${color}`,
            padding: "3px 6px 3px 8px",
            minHeight: "26px",
            lineHeight: "18px",
            whiteSpace: "normal",
            wordBreak: "break-word",
          }}
        >
          {renderContent(candidate)}
        </div>
      );
    })}
  </>
);

const Candidate = ({ ...props }) => (
  <Cell {...props}>
    <span>
      {props.rowData.Candidate} {props.rowData.CandidateLastName}
    </span>
  </Cell>
);

const SwimlaneCandidateAcceptedDate = ({ ...props }) => {
  const acceptedCandidates = props.rowData.swimLaneAcceptedCandidate || [];
  return (
    <Cell {...props} style={{ padding: 0 }}>
      <RecruiterSubCell
        candidates={acceptedCandidates}
        recruiterColors={props.recruiterColors}
        renderContent={(candidate) => (
          <span style={{ fontWeight: "bold", fontSize: 12 }}>
            {`${candidate.FirstName} ${candidate.LastName} (${format(
              new Date(candidate.AcceptedDate),
              GetUserDateFormat("date")
            )})${candidate.StatusId === CANDIDATE_STATUS.ONHOLD ? CANDIDATE_STATUS_LABEL.ON_HOLD_SUFFIX : ""}`}
          </span>
        )}
      />
    </Cell>
  );
};

const FocusArea = ({ ...props }) => (
  <Cell {...props}>
    <span title={props.rowData?.FocusArea}>{props.rowData?.FocusArea}</span>
  </Cell>
);
const Designationcell = ({ ...props }) => (
  <Cell {...props}>
    <span title={props.rowData?.Designation}>{props.rowData?.Designation}</span>
  </Cell>
);
const Projectcell = ({ ...props }) => (
  <Cell {...props}>
    <span title={props.rowData?.ProjectId}>{props.rowData?.ProjectId}</span>
  </Cell>
);

const ScheduleComments = ({ ...props }) => (
  <Cell {...props}>
    <span title={props.rowData?.ScheduleComments}>
      {props.rowData?.ScheduleComments}
    </span>
  </Cell>
);
const HRComments = ({ ...props }) => (
  <Cell {...props}>
    <span title={props.rowData?.HRComments}>{props.rowData?.HRComments}</span>
  </Cell>
);

// Display Date column
const DateCell = ({ ...props }) => {
  return (
    <Cell {...props}>
      <span>
        {props.rowData.CreatedDate &&
          format(
            new Date(props.rowData.CreatedDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.RequestDate &&
          format(
            new Date(props.rowData.RequestDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.Schedule &&
          format(
            new Date(props.rowData.Schedule),
            GetUserDateFormat("dateTime")
          )}
        {props.rowData.ScheduleDateTime &&
          format(
            new Date(props.rowData.ScheduleDateTime),
            GetUserDateFormat("dateTime")
          )}
        {props.rowData.ScheduleDate &&
          format(
            new Date(props.rowData.ScheduleDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.StatusUpdatedDate && (
          <span
            title={format(
              new Date(props.rowData.StatusUpdatedDate),
              GetUserDateFormat("date")
            )}
          >
            {format(
              new Date(props.rowData.StatusUpdatedDate),
              GetUserDateFormat("date")
            )}
          </span>
        )}
        {props.rowData.RequestDueDate &&
          props.ColumnName == "RequestDueDate" &&
          format(
            new Date(props.rowData.RequestDueDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.DateOfOffer &&
          props.ColumnName == "DateOfOffer" &&
          format(
            new Date(props.rowData.DateOfOffer),
            GetUserDateFormat("date")
          )}

        {props.rowData.ApprovedDate &&
          props.ColumnName == "ApprovedDate" &&
          format(
            new Date(props.rowData.ApprovedDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.JoiningDate &&
          props.ColumnName == "JoiningDate" &&
          format(
            new Date(props.rowData.JoiningDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.offeredDate &&
          format(
            new Date(props.rowData.offeredDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.StatusDate &&
          format(new Date(props.rowData.StatusDate), GetUserDateFormat("date"))}
        {props.rowData.ProjectStartDate &&
          props.ColumnName == "ProjectStartDate" &&
          format(
            new Date(props.rowData.ProjectStartDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.ProjectEndDate &&
          props.ColumnName == "ProjectEndDate" &&
          format(
            new Date(props.rowData.ProjectEndDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.createdAt &&
          props.ColumnName == "createdDate" &&
          format(new Date(props.rowData.createdAt), GetUserDateFormat("date"))}
        {props.rowData.updatedAt &&
          props.ColumnName == "updatedDate" &&
          format(new Date(props.rowData.updatedAt), GetUserDateFormat("date"))}
        {props.rowData.LatestInterviewDate &&
          props.ColumnName == "LatestInterviewDate" &&
          format(
            new Date(props.rowData.LatestInterviewDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.OfferedDate &&
          props.ColumnName == "OfferedDate" &&
          format(
            new Date(props.rowData.OfferedDate),
            GetUserDateFormat("date")
          )}
        {props.rowData.LastScheduleDateTime &&
          props.ColumnName == "LastScheduleDateTime" &&
          format(new Date(props.rowData.LastScheduleDateTime), "MMM, yyyy")}
          {props.rowData.DropOutDate &&
          props.ColumnName == "DropOutDate" &&
          format(
            new Date(props.rowData.DropOutDate),
            GetUserDateFormat("date")
          )}
          {props.rowData.UpdatedDate &&
          props.ColumnName == "UpdatedDate" &&
          format(
            new Date(props.rowData.UpdatedDate),
              GetUserDateFormat("date")
          )}
          {props.rowData.ExpectedDateOfJoining &&
          props.ColumnName == "ExpectedDateOfJoining" &&
          format(
            new Date(props.rowData.ExpectedDateOfJoining),
            GetUserDateFormat("date")
          )}
          {props.rowData.ActualDateOfJoining &&
          props.ColumnName == "ActualDateOfJoining" &&
          format(
            new Date(props.rowData.ActualDateOfJoining),
            GetUserDateFormat("date")
          )}
          {props.rowData.RequiredBy &&
          props.ColumnName == "RequiredBy" &&
          format(
            new Date(props.rowData.RequiredBy),
            GetUserDateFormat("date")
          )}
           {props.rowData.ApprovalDate &&
          props.ColumnName == "ApprovalDate" &&
          format(
            new Date(props.rowData.ApprovalDate),
            GetUserDateFormat("date")
          )}
      </span>
    </Cell>
  );
};

const JoiningDateCell = ({ ...props }) => (
  <Cell {...props}>
    <span>
      {props.rowData.CandidateStatusUpdatedDate &&
        format(
          new Date(props.rowData.CandidateStatusUpdatedDate),
          GetUserDateFormat("date")
        )}
      {props.rowData?.JoinedDate &&
        format(new Date(props.rowData.JoinedDate), GetUserDateFormat("date"))}
    </span>
  </Cell>
);

const MonthCell = ({ ...props }) => {
  return (
    <Cell {...props}>
      <span>
        {props.rowData.MaxDateTime &&
          format(new Date(props.rowData?.MaxDateTime), "MMM, yyyy")}
      </span>
    </Cell>
  );
};
const DesignationDateCell = ({ ...props }) => {
  const acceptedCandidates = props.rowData.swimLaneAcceptedCandidate || [];
  const color =
    props.recruiterColors?.[
      acceptedCandidates[0]?.CreatedByEmployeeId
    ] || null;

  return (
    <Cell
      {...props}
      style={{
        padding: 0,
        overflow: "hidden", // prevent bleed outside cell
      }}
    >
      <div
        style={{
          height: "100%",
          borderLeft: `8px solid ${color}`,
          backgroundColor: `${color}`,
          padding: "4px 6px 4px 8px",
          display: "flex",
          alignItems: "center",
          whiteSpace: "normal",   // allow wrap inside cell
          wordBreak: "break-word",
          lineHeight: "18px",
        }}
      >
        <span style={{ fontWeight: "bold", fontSize: 12 }}>
          {props.rowData.RequirementCreatedDate &&
            `${props.rowData.Designation} (${format(
              new Date(props.rowData.RequirementCreatedDate),
              GetUserDateFormat("date")
            )})`}
        </span>
      </div>
    </Cell>
  );
};

const LeadtimeDaysCell = ({ ...props }) => {
  const acceptedCandidates = props.rowData.swimLaneAcceptedCandidate || [];
  return (
    <Cell {...props} style={{ padding: 0 }}>
      <RecruiterSubCell
        candidates={acceptedCandidates}
        recruiterColors={props.recruiterColors}
        renderContent={(leadTime) => (
          <span style={{ fontWeight: "bold", fontSize: 12 }}>
            {leadTime.SwimLaneLeadTimeDays}
          </span>
        )}
      />
    </Cell>
  );
};

const SwimlaneSrNo = ({ ...props }) => {
  const acceptedCandidates = props.rowData.swimLaneAcceptedCandidate || [];
  const color = props.recruiterColors?.[acceptedCandidates[0]?.CreatedByEmployeeId] 

  return (
    <Cell {...props} style={{ padding: 0, overflow: "hidden" }}>
      <div
        style={{
          height: "100%",
          borderLeft: `8px solid ${color}`,
          backgroundColor: `${color}`,
          padding: "4px 8px",
          display: "flex",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: 12,
        }}
      >
        {props.rowData.swimLaneSrNo}
      </div>
    </Cell>
  );
};
const CandidateJoinDate = ({ ...props }) => {

  return (
    <Cell {...props}>
      <span>
        {props.rowData.CandidateJoiningDate &&
          format(
            new Date(props.rowData.CandidateJoiningDate),
            GetUserDateFormat("date")
          )}
      </span>
    </Cell>
  );
};
const CandidateOfferedDate = ({ ...props }) => {

  return (
    <Cell {...props}>
      <span>
        {props.rowData.CandidateOfferedDate &&
          format(
            new Date(props.rowData.CandidateOfferedDate),
            GetUserDateFormat("date")
          )}
      </span>
    </Cell>
  );
};

// Display Action column
const ActionCell = ({ ...props }) => {
  return (
    <>
      {props.listName === "RoleList" &&
      checkCurrentRoleIsSuperAdmin(props.rowData.Name) ? (
        <Cell {...props}></Cell>
      ) : (
        <Cell {...props}>
          <EPOverLay
            rowData={props.rowData}
            triggerComp={
              <span>
                <BiDotsVerticalRounded />
              </span>
            }
            RequirementId={props.RequirementId}
            data={props.data}
            setDataList={props.setDataList}
            listName={props.listName}
            functionMethod={props.functionMethod}
            setRefresher={props.setRefresher}
            refresher={props.refresher}
            PageAccess={props.PageAccess}
            setLoading={props.setLoading}
            availableLimit={props.availableLimit}
            setAvailableLimit={props.setAvailableLimit}
          />
        </Cell>
      )}
    </>
  );
};

// Display status column
const StatusCell = ({ ...props }) => (
  <Cell {...props}>{displayStatusCell(props.rowData.StatusName)}</Cell>
);

const displayStatusCell = (status: string) => {
  switch (status) {
    case "Draft":
      return <span className="status-draft">{status}</span>;
    case "Open":
      return <span className="status-open">{status}</span>;
    case "In Progress":
      return <span className="status-ip">{status}</span>;
    case "Closed":
      return <span className="status-closed">{status}</span>;
    case "Cancelled":
      return <span className="status-cancel">{status}</span>;
    default:
      return <span className="status-draft">{status}</span>;
  }
};
// Display candidate first and last name
const CandidateName = ({ ...props }) => (
  <Cell {...props}>
    <span>
      {props.rowData.FirstName} {props.rowData.LastName}
    </span>
  </Cell>
);

const TechnicalRoundInterviewer = ({ ...props }) => {
  const round = props?.round;
  const rowData = props?.rowData;
  const primaryInterviewer =
    rowData?.[`TechRound${round}PrimaryInterviewer`] || "";
  const secondaryInterviewer =
    rowData?.[`TechRound${round}SecondaryInterviewer`] || "";
  return (
    <Cell {...props}>
      <span>
        {primaryInterviewer}
        {secondaryInterviewer.trim() ? `, ${secondaryInterviewer}` : ""}
      </span>
    </Cell>
  );
};

const ManagementRoundInterviewer = ({ ...props }) => {
  const round = props?.round;
  const rowData = props?.rowData;
  const primaryInterviewer =
    rowData?.[`ManagementRound${round}PrimaryInterviewer`] || "";
  const secondaryInterviewer =
    rowData?.[`ManagementRound${round}SecondaryInterviewer`] || "";
  return (
    <Cell {...props}>
      <span>
        {primaryInterviewer}
        {secondaryInterviewer.trim() ? `, ${secondaryInterviewer}` : ""}
      </span>
    </Cell>
  );
};

const HRRoundInterviewer = ({ ...props }) => {
  const round = props?.round;
  const rowData = props?.rowData;
  const primaryInterviewer =
    rowData?.[`HRRound${round}PrimaryInterviewer`] || "";
  const secondaryInterviewer =
    rowData?.[`HRRound${round}SecondaryInterviewer`] || "";
  return (
    <Cell {...props}>
      <span>
        {primaryInterviewer}
        {secondaryInterviewer.trim() ? `, ${secondaryInterviewer}` : ""}
      </span>
    </Cell>
  );
};

const CandidateGender = ({ ...props }) => (
  <Cell {...props}>
    <span>{props.rowData.Gender === "F" ? "Female" : "Male"}</span>
  </Cell>
);

const Timecell = ({ ...props }) => {
  const dateObj = new Date(props.rowData.ScheduleTime);
  return (
    <Cell {...props}>
      <span>
        {dateObj.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })}
      </span>
    </Cell>
  );
};

const InterviewerName = ({ ...props }) => {
  return (
    <Cell {...props}>
      <span title={props.rowData.InterviewersName.join(", ")}>
        {props.rowData.InterviewersName.join(", ")}
      </span>
    </Cell>
  );
};
const PrimarySecondaryInterviewerName = ({ ...props }) => {
  return (
    <Cell {...props}>
      <span>
        {`${props.rowData?.PrimaryInterviewer || ""}${
          props.rowData?.PrimaryInterviewer &&
          props.rowData?.SecondaryInterviewer
            ? ", "
            : ""
        }${props.rowData?.SecondaryInterviewer || ""}`}
      </span>
    </Cell>
  );
};

const ScheduleTypeName = ({ ...props }) => {
  const getScheduleTypeName = (type: number) => {
    switch (type) {
      case CommonConstants.PERSONAL:
        return "Personal";
      case CommonConstants.MS_TEAMS:
        return "MS Teams";
      case CommonConstants.ZOOM:
        return "Zoom";
      case CommonConstants.GOOGLE_MEET:
        return "Google Meet";
      default:
        return "Unknown";
    }
  };

  return (
    <Cell {...props}>
      <span>{getScheduleTypeName(props?.rowData?.ScheduleType)}</span>
    </Cell>
  );
};

const InterviewTypeName = ({ ...props }) => {
  return <Cell {...props}>{props?.rowData?.ScheduleType}</Cell>;
};

const HideCredentials = ({ ...props }) => {
  return (
    <Cell {...props}>
      <span>*******************</span>
    </Cell>
  );
};

const CandidateReference = ({ ...props }) => (
  <Cell {...props}>
    <span>
      {props.rowData.ReferenceName
        ? props.rowData.ReferenceName === "Consultant"
          ? `${props.rowData.ReferenceName} - ${props.rowData.ConsultantName}`
          : props.rowData.ReferenceName
        : props.rowData.ReferencedBy
        ? `${props.rowData.ReferencedBy}(Employee ref.)`
        : ""}
    </span>
  </Cell>
);

const CandidateReferenceReferralReport = ({ ...props }) => (
  <Cell {...props}>
    <span>
      {props.rowData.SourceReference
        ? props.rowData.ReferenceName === "Consultant"
          ? `${props.rowData.ReferenceName} - ${props.rowData.ConsultantName}`
          : props.rowData.ReferenceName
        : props.rowData.ReferencedBy
        ? `${props.rowData.ReferencedBy}(Employee ref.)`
        : ""}
    </span>
  </Cell>
);

const CallingCandidateReference = ({ ...props }) => (
  <Cell {...props}>
    <span>
      {props.rowData.ReferencedEmployee || props.rowData.ReferencedSource}
    </span>
  </Cell>
);

const CallingCandidateStatus = ({ ...props }) => (
  <Cell {...props}>
    <span>{props.rowData.StatusId || props.rowData.CurrentStatus}</span>
  </Cell>
);

const EmailStatusCell = ({ ...props }) => (
  <Cell {...props}>
    <span>{props.rowData.EmailVerified ? "Verified" : "Pending"}</span>
  </Cell>
);

const RequirementMappingIcon = ({ ...props }) => {
  return (
    <Cell {...props}>
      <AiOutlineLink
        style={{
          color: "#00aeef",
          fontSize: "20px",
          cursor: "Pointer",
        }}
        onClick={() => {
          props?.functionMethod((data: any) => {
            return {
              ...data,
              ["RequirementId"]: props?.rowData?.RequirementId,
            };
          });
          props?.HandleModel();
        }}
      />
    </Cell>
  );
};

const FeedBackIconInManageCandidateStatusPopUp = ({ ...props }) => {
  const navigate = useNavigate();

  const { Status } = props.rowData;
  const StatusOption = [
    "Suitable",
    "Can be considered",
    "Needs Second Opinion",
    "Rejected",
  ];
  const shouldDisplayLink = StatusOption?.includes(Status);
  let EnableLink = true;
  if (shouldDisplayLink) {
    EnableLink = true;
  } else {
    EnableLink = false;
  }
  return (
    <Cell {...props}>
      {EnableLink && (
        <AiOutlineLink
          style={{
            color: EnableLink ? "#00aeef" : "gray",
            fontSize: "20px",
            cursor: EnableLink ? "Pointer" : "",
          }}
          onClick={() => {
            if (EnableLink) {
              navigate(
                `/myInterview/interviewSheetFeedbackView/${props?.rowData?.CandidateId}/${props?.rowData?.RequirementId}`
              );
            }
          }}
        />
      )}
    </Cell>
  );
};

const CandidateRound = ({ ...props }) => (
  <Cell
    title={
      props.rowData.Round
        ? `${props.rowData.Round} - ${props.rowData.RoundCount}`
        : "-"
    }
    {...props}
  >
    <span>
      {props.rowData.Round
        ? `${props.rowData.Round} - ${props.rowData.RoundCount}`
        : "-"}
    </span>
  </Cell>
);

const Status = ({ ...props }) => {
  const { user }: any = useContext(UserContext);
  const PageAccess: string[] =
    user.RoleAccess[location.pathname?.split("/").join("").toLowerCase()];
  const [openViewCandidateHistory, setOpenViewCandidateHistory] =
    useState<boolean>(false);

  const styleObj = {
    color: "#1daeef",
  };

  const defaultStyle = {};

  function viewCandidateHistory() {
    if (
      (props.listName === "manageCandidate" &&
        props.rowData.ScheduleDateTime &&
        props.rowData.StatusId !== "In progress" &&
        // props.rowData.RequirementId &&
        PageAccess?.includes("Interview History")) ||
      PageAccess?.includes("All")
    ) {
      setOpenViewCandidateHistory(true);
    }
  }

  return (
    <>
      {openViewCandidateHistory && (
        <ViewCandidateHistoryModal
          openViewCandidateHistory={openViewCandidateHistory}
          setOpenViewCandidateHistory={setOpenViewCandidateHistory}
          data={props.rowData}
        />
      )}
      <Cell
        {...props}
        onClick={viewCandidateHistory}
        title={props.rowData?.StatusId}
        style={{
          cursor:
            props.rowData.ScheduleDateTime &&
            props.rowData.RequirementId &&
            props.rowData.StatusId !== "In progress"
              ? "pointer"
              : "default",
        }}
      >
        <span
          style={
            props.rowData.ScheduleDateTime &&
            props.rowData.RequirementId &&
            props.rowData.StatusId !== "In progress"
              ? styleObj
              : defaultStyle
          }
        >
          {props.rowData?.StatusId}
        </span>
      </Cell>
    </>
  );
};

const ManageRequestCandidateShortListspopUp = ({ ...props }) => {
  const [CandidateRequestHistory, setCandidateRequestHistory] =
    useState<boolean>(false);
  function viewCandidateHistory() {
    if (props.listName === "manageRequest") {
      setCandidateRequestHistory(true);
    }
  }
  return (
    <>
      {CandidateRequestHistory && (
        <CandidateRequestModal
          openViewCandidateHistory={CandidateRequestHistory}
          setOpenViewCandidateHistory={setCandidateRequestHistory}
          data={props.rowData}
          dataKey={props.dataKey}
        />
      )}
      <Cell
        {...props}
        onClick={viewCandidateHistory}
        title={props.rowData?.StatusId}
        style={{ cursor: "Pointer" }}
        // style={{
        //   cursor:
        //     props.rowData.ScheduleDateTime && props.rowData.RequirementId
        //       ? "pointer"
        //       : "default",
        // }}
      >
        {props.rowData?.StatusId}
      </Cell>
    </>
  );
};

const SwimelaneShortListCandidateName = ({ ...props }) => {
  const candidates = props.rowData?.[props.dataKey] || [];
  return (
    <Cell {...props} style={{ padding: 0 }}>
      <RecruiterSubCell
        candidates={candidates}
        recruiterColors={props.recruiterColors}
        renderContent={(candidate) => (
          <span style={{ fontWeight: "bold", fontSize: 12 }}>
            {`${candidate.FirstName} ${candidate.LastName} (${format(
              new Date(candidate.ScheduleDateTime),
              GetUserDateFormat("date")
            )})${candidate.StatusId === CANDIDATE_STATUS.ONHOLD ? CANDIDATE_STATUS_LABEL.ON_HOLD_SUFFIX : ""}`}
          </span>
        )}
      />
    </Cell>
  );
};

// Common function to display cell
const displayCell = (columnKey: string, { ...props }, functionMethod?: any) => {
  switch (columnKey) {
    case "RequestDate":
      return <DateCell dataKey={columnKey} />;
    case "CreatedDate":
      return <DateCell dataKey={columnKey} />;
    case "updatedAt":
      return <DateCell dataKey={columnKey} ColumnName="updatedDate" />;
    case "createdAt":
      return <DateCell dataKey={columnKey} ColumnName="createdDate" />;
    case "ProjectStartDate":
      return <DateCell dataKey={columnKey} ColumnName="ProjectStartDate" />;
    case "ProjectEndDate":
      return <DateCell dataKey={columnKey} ColumnName="ProjectEndDate" />;
    case "CandidateStatusUpdatedDate":
      return <JoiningDateCell dataKey={columnKey} />;
    case "Schedule":
      return <DateCell dataKey={columnKey} />;
    case "ScheduleDate":
      return <DateCell dataKey={columnKey} />;
    case "StatusUpdatedDate":
      return <DateCell dataKey={columnKey} />;
    case "JoinedDate":
      return <JoiningDateCell dataKey={columnKey} />;
    case "offeredDate":
      return <DateCell dataKey={columnKey} />;
    case "swimLaneAcceptedCandidate":
      return (
        <SwimlaneCandidateAcceptedDate
          dataKey={columnKey}
          recruiterColors={props.recruiterColors}
        />
      );
    case "ExperienceCell":
      return <ExperienceCell />;
    case "Experience":
      return <Experience dataKey={columnKey} listName={props?.listName} />;
    case "Candidate":
      return <Candidate dataKey={columnKey} />;
    case "Round":
      return <Round dataKey={columnKey} />;
    case "StatusName":
      return <StatusCell dataKey={columnKey} />;
    case "FocusArea":
      return <FocusArea dataKey={columnKey} />;
    case "ScheduleComments":
      return <ScheduleComments dataKey={columnKey} />;
    case "HRComments":
      return <HRComments dataKey={columnKey} />;
    case "StatusDate":
      return <DateCell dataKey={columnKey} />;
    case "CandidateJoiningDate":
      return <CandidateJoinDate dataKey={columnKey} />;
    case "CandidateOfferedDate":
      return <CandidateOfferedDate dataKey={columnKey} />;
    case "SwimLaneDesignation":
      return (
        <DesignationDateCell
          dataKey={columnKey}
          recruiterColors={props.recruiterColors}
        />
      );
    case "SwimLaneLeadTimeDays":
      return (
        <LeadtimeDaysCell
          dataKey={columnKey}
          recruiterColors={props.recruiterColors}
        />
      );
    case "swimLaneSrNo":
      return (
        <SwimlaneSrNo
          dataKey={columnKey}
          recruiterColors={props.recruiterColors}
        />
      );

    case "Select":
      return (
        <RequirementMappingIcon
          dataKey={columnKey}
          functionMethod={functionMethod}
          HandleModel={props?.HandleModel}
        />
      );
    case "Feedback":
      return <FeedBackIconInManageCandidateStatusPopUp dataKey={columnKey} />;
    case "PrimaryInterviewer":
      return <PrimarySecondaryInterviewerName dataKey={columnKey} />;
    case "ScheduleType":
      return <ScheduleTypeName dataKey={columnKey} />;
    case "InterviewType":
      return <InterviewTypeName dataKey={columnKey} />;
    case "Credentials":
      return <HideCredentials dataKey={columnKey} />;
    case "Action":
      return (
        <ActionCell
          data={props.data}
          RequirementId={props.RequirementId}
          PageAccess={props.PageAccess}
          setDataList={props.setDataList}
          listName={props.listName}
          functionMethod={props.functionMethod}
          setRefresher={props.setRefresher}
          refresher={props.refresher}
          setLoading={props.setLoading}
          availableLimit={props.availableLimit}
          setAvailableLimit={props.setAvailableLimit}
        />
      );
    case "candidateName":
      return <CandidateName dataKey={columnKey} />;
    case "Gender":
      return <CandidateGender dataKey={columnKey} />;
    case "reference":
      return <CandidateReference dataKey={columnKey} />;
    case "CallingCandidateReference":
      return <CallingCandidateReference dataKey={columnKey} />;
    case "CurrentStatusOfCallingCandidate":
      return <CallingCandidateStatus dataKey={columnKey} />;
    case "ReferencedBy":
      return <CandidateReferenceReferralReport dataKey={columnKey} />;
    case "round":
      return <CandidateRound dataKey={columnKey} />;
    case "ScheduleDateTime":
      return <DateCell dataKey={columnKey} />;
    case "InterviewersName":
      return <InterviewerName dataKey={columnKey} />;
    case "StatusId":
      return (
        <Status
          dataKey={columnKey}
          listName={props.listName}
          user={props?.user}
        />
      );
    case "NoOfInterviewSchedule":
    case "NoOfShortListCandidate":
    case "RejectedCandidate":
    case "OfferedCandidate":
    case "JoinedCandidate":
      return (
        <ManageRequestCandidateShortListspopUp
          dataKey={columnKey}
          listName={props.listName}
          // user={props?.user}
        />
      );

    case "swimLaneTechnical1SL":
    case "swimLaneTechnical2SL":
    case "swimLaneTechnical3SL":
    case "swimLaneManagement1SL":
    case "swimLaneManagement2SL":
    case "swimLaneHR1SL":
      return (
        <SwimelaneShortListCandidateName
          dataKey={columnKey}
          listName={props.listName}
          recruiterData={props.recruiterData}
          recruiterColors={props.recruiterColors}
          // user={props?.user}
        />
      );

    case "ScheduleTime":
      return <Timecell dataKey={columnKey} />;
    case "MaxDateTime":
      return <MonthCell dataKey={columnKey} />;
    case "Designation":
      return <Designationcell dataKey={columnKey} />;
    case "ProjectId":
      return <Projectcell dataKey={columnKey} />;
    case "DisplaySequence":
      return (
        <OrderByEditing
          dataKey={columnKey}
          setRefresher={props.setRefresher}
          refresher={props.refresher}
          totalRecords={props.totalRecords}
        />
      );
    case "RequestDueDate":
      return <DateCell dataKey={columnKey} ColumnName="RequestDueDate" />;
    case "DateOfOffer":
      return <DateCell dataKey={columnKey} ColumnName="DateOfOffer" />;
    case "ApprovedDate":
      return <DateCell dataKey={columnKey} ColumnName="ApprovedDate" />;
    case "JoiningDate":
      return <DateCell dataKey={columnKey} ColumnName="JoiningDate" />;
    case "EmailVerified":
      return <EmailStatusCell dataKey={columnKey ? "Verified" : "Pending"} />;
    case "LatestInterviewDate":
      return <DateCell dataKey={columnKey} ColumnName="LatestInterviewDate" />;
    case "OfferedDate":
      return <DateCell dataKey={columnKey} ColumnName="OfferedDate" />;
    case "LastScheduleDateTime":
      return <DateCell dataKey={columnKey} ColumnName="LastScheduleDateTime" />;
    case "DropOutDate":
      return <DateCell dataKey={columnKey} ColumnName="DropOutDate" />;
     case "UpdatedDate":
      return <DateCell dataKey={columnKey} ColumnName="UpdatedDate" />;
    case "ExperienceMonth":
      return <ExperienceMonth dataKey={columnKey} listName={props?.listName} />;
    case "ExpectedDateOfJoining":
      return <DateCell dataKey={columnKey} ColumnName="ExpectedDateOfJoining" />;
    case "ActualDateOfJoining":
      return <DateCell dataKey={columnKey} ColumnName="ActualDateOfJoining" />;
    case "ApprovalDate":
      return <DateCell dataKey={columnKey} ColumnName="ApprovalDate" />;
    case "RequiredBy":
      return <DateCell dataKey={columnKey} ColumnName="RequiredBy" />;

    default:
      if (
        columnKey.startsWith("TechRound") &&
        columnKey.includes("Interviewer")
      ) {
        const roundNumber = columnKey.match(/TechRound(\d+)(\w+)/)?.[1];
        return <TechnicalRoundInterviewer round={roundNumber} />;
      } else if (
        columnKey.startsWith("ManagementRound") &&
        columnKey.includes("Interviewer")
      ) {
        const roundNumber = columnKey.match(/ManagementRound(\d+)(\w+)/)?.[1];
        return <ManagementRoundInterviewer round={roundNumber} />;
      } else if (
        columnKey.startsWith("HRRound") &&
        columnKey.includes("Interviewer")
      ) {
        const roundNumber = columnKey.match(/HRRound(\d+)(\w+)/)?.[1];
        return <HRRoundInterviewer round={roundNumber} />;
      }
      return <Cell dataKey={columnKey} />;
  }
};

export const EPTable = (props: Props) => {
  const {
    data,
    columns,
    height,
    // RequirementId,
    sortColumn,
    sortType,
    onSortColumn,
    loading,
    rowHeight,
    headerHeight,
    // setDataList,
    // listName,
    // refresher,
    // setRefresher,
    functionMethod,
    // PageAccess,
    // setData,
    // HandleModel,
    // user,
    // setLoading,
    wordWrap,
  } = props;

  return (
    <Table
      wordWrap={wordWrap}
      height={height}
      data={data}
      sortColumn={sortColumn}
      sortType={sortType}
      onSortColumn={onSortColumn}
      loading={loading}
      rowHeight={rowHeight}
      headerHeight={headerHeight}
    >
      {columns?.map((column: Column) => {
        if (column.IsColumnGroup) {
          return (
            <ColumnGroup
              header={column.label}
              align="center"
              groupHeaderHeight={31}
            >
              {column?.ColumnGroups?.map((subColumn: Column) => (
                <Column
                  verticalAlign="top"
                  key={subColumn.key}
                  width={subColumn.width}
                  fixed={subColumn.fixed}
                  sortable={subColumn.sortable}
                  flexGrow={subColumn.flexGrow}
                  resizable={subColumn.resizable}
                  align={subColumn.align}
                >
                  <HeaderCell>{subColumn.label}</HeaderCell>
                  {displayCell(subColumn.key, { ...props }, functionMethod)}
                  {/* <Cell dataKey={subColumn.key} /> */}
                </Column>
              ))}
            </ColumnGroup>
          );
        } else {
          return (
            <Column
              key={column.key}
              width={column.width}
              fixed={column.fixed}
              sortable={column.sortable}
              flexGrow={column.flexGrow}
              resizable={column.resizable}
              align={column.align}
            >
              <HeaderCell title={column.title}>{column.label}</HeaderCell>
              {displayCell(column.key, { ...props }, functionMethod)}
            </Column>
          );
        }
      })}
    </Table>
  );
};
